/**
 * Mixin for any custom QSelect components
 *
 * All functions can be used on any fields which uses  a custom QSelect-like component.
 */
export default {
  emits: ['clickedResult', 'removedResult', 'update:modelValue', 'clear'],
  methods: {
    // Result in list is clicked
    onResultClick (val, newModel = false) {
      if (Array.isArray(this.modelValue)) {
        if (this.modelValue.map(item => item.id).includes(val.id)) {
          const payload = this.modelValue.filter(item => item.id !== val.id)
          this.onUpdateVal(payload)
        }
        else {
          this.onUpdateVal(this.modelValue.concat([val]), newModel)
        }
      }
      else {
        if (this.modelValue && this.modelValue.id === val.id) {
          this.onClearVal()
        }
        else {
          this.onUpdateVal(val, newModel)
        }
      }
    },
    // Check if a result is selected by ID
    isResultSelected (id) {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.map(item => item.id).includes(id)
      }
      return this.modelValue && this.modelValue.id === id
    },
    // Perform an update on a model
    onUpdateVal (val, newModel = false) {
      let status

      if (!val) {
        return
      }
      if (!Array.isArray(this.modelValue)) {
        if (val) {
          status = 'click'
          this.$emit('clickedResult', val, newModel)
        }
        else {
          status = 'remove'
          this.$emit('removedResult', this.modelValue)
        }
      }
      else {
        const difference = val.filter(x => !this.modelValue.includes(x))
        if (difference.length > 0) {
          status = 'click'
          this.$emit('clickedResult', difference[0], newModel)
        }
        else {
          const invDifference = this.modelValue.filter(x => !val.includes(x))
          if (invDifference.length > 0) {
            status = 'remove'
            this.$emit('removedResult', invDifference[0])
          }
        }
      }
      this.$emit('update:modelValue', val)
      return status
    },
    // Clear model
    onClearVal () {
      if (Array.isArray(this.modelValue)) {
        this.$emit('update:modelValue', [])
      }
      else {
        this.$emit('update:modelValue', null)
      }
      this.$emit('clear')
    },
    // Find a model in the result set and replace it with new data
    findAndReplaceModel (model) {
      if (Array.isArray(this.modelValue)) {
        const index = this.modelValue.map(item => item.id).indexOf(model.id)
        if (index > -1) {
          const payload = this.modelValue.filter((val, i) => i !== index)
          payload.push(model)
          this.onUpdateVal(payload)
        }
      }
      else {
        this.onUpdateVal(model)
      }
    },
    // Remove a model value based on its ID
    async findAndRemoveModel (id) {
      if (Array.isArray(this.modelValue)) {
        const index = this.modelValue.map(item => item.id).indexOf(id)
        if (index > -1) {
          await this.removeModelAtIndex(index)
        }
      }
      else {
        await this.removeModelAtIndex()
      }
    },
    // Remove a model from the result set at index
    async removeModelAtIndex (index) {
      if (Array.isArray(this.modelValue)) {
        if (index !== null && index > -1) {
          await this.$emit('removedResult', this.modelValue[index])
          this.$emit('update:modelValue', this.modelValue.filter((val, i) => i !== index))
        }
      }
      else {
        await this.$emit('removedResult', this.modelValue)
        this.$emit('update:modelValue', null)
      }
    }
  }
}
